import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import { normalizeSupportedLanguageCode } from "../utils/resolveSupportedLanguageCode";
import { enUS } from "../translations/en-US";
import { esES } from "../translations/es-ES";
import { ptBR } from "../translations/pt-BR";
import { zhCN } from "../translations/zh-CN";

const cachedLanguage = (() => {
  try {
    return normalizeSupportedLanguageCode(localStorage.getItem("i18nextLng"));
  } catch {
    return null;
  }
})();

i18next.use(initReactI18next).init({
  lng: cachedLanguage ?? "pt-BR",
  fallbackLng: "pt-BR",
  resources: {
    "pt-BR": { translation: ptBR },
    "en-US": { translation: enUS },
    "es-ES": { translation: esES },
    "zh-CN": { translation: zhCN },
  },
  interpolation: { escapeValue: false },
});

export default i18next;
